(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["oix-vanity-content"] && !Shopify.designMode) return;
  try {
    const syncDedicatedVanityGalleries = () => {
    document.querySelectorAll('.oix-vanity-product[data-oix-vanity-dedicated-variants]').forEach((productSection) => {
      const mediaData = productSection.querySelector('[data-oix-vanity-variant-media]');
      if (!mediaData) return;
      let mapping;
      try {
        mapping = JSON.parse(mediaData.textContent);
      } catch {
        return;
      }
      if (!Array.isArray(mapping.selectedGalleryMediaIds)) return;
      const mediaId = mapping.selectedMediaId;
      if (!mapping.selectedGalleryMediaIds.map(String).includes(String(mediaId))) return;
      if (!mediaId) return;
      const selectedMediaKey = `${productSection.dataset.section}-${mediaId}`;
      const mainGallery = productSection.querySelector('.js-media-list');
      const thumbGallery = productSection.querySelector('.js-media-sublist');
      const mainSlide = Array.from(mainGallery?.querySelectorAll('[data-media-id]') || []).find((slide) => slide.dataset.mediaId === selectedMediaKey);
      const thumbSlide = Array.from(thumbGallery?.querySelectorAll('[data-media-sub-id]') || []).find((slide) => slide.dataset.mediaSubId === selectedMediaKey);
      if (!mainSlide || !thumbSlide) return;
      mainSlide.parentElement.prepend(mainSlide);
      thumbSlide.parentElement.prepend(thumbSlide);
      [mainGallery, thumbGallery].forEach((gallery) => {
        if (typeof gallery.swiper?.update === 'function') gallery.swiper.update();
        if (typeof gallery.swiper?.slideTo === 'function') gallery.swiper.slideTo(0, 0, false);
      });
    });
  };
  if (document.readyState === 'complete') syncDedicatedVanityGalleries();
  else window.addEventListener('load', syncDedicatedVanityGalleries, { once: true });
  document.addEventListener('shopify:section:load', () => requestAnimationFrame(syncDedicatedVanityGalleries));
  document.addEventListener('change', (event) => {
    if (!(event.target instanceof HTMLSelectElement)) return;
    if (!event.target.matches('.oix-vanity-product[data-oix-vanity-dedicated-variants] [data-oix-vanity-variant-select]')) return;
    const productSection = event.target.closest('.oix-vanity-product[data-oix-vanity-dedicated-variants]');
    if (!productSection || event.target.value === productSection.dataset.oixVanitySelectedVariant) return;
    productSection.dataset.oixVanityNavigating = 'true';
    productSection.setAttribute('aria-busy', 'true');
    event.target.disabled = true;
    productSection.querySelectorAll('product-form').forEach((form) => form.setAttribute('inert', ''));
    productSection.querySelectorAll('product-form [type="submit"]').forEach((button) => {
      button.disabled = true;
      button.setAttribute('aria-disabled', 'true');
    });
    const variantUrl = new URL(window.location.href);
    variantUrl.searchParams.set('variant', event.target.value);
    window.location.assign(variantUrl.href);
  });
  document.addEventListener('submit', (event) => {
    if (!event.target.matches('form[data-type="add-to-cart-form"]')) return;
    const productSection = event.target.closest('.oix-vanity-product[data-oix-vanity-dedicated-variants]');
    if (!productSection) return;
    const variantInput = event.target.querySelector('input[name="id"]');
    if (productSection.dataset.oixVanityNavigating === 'true' || variantInput?.value !== productSection.dataset.oixVanitySelectedVariant) {
      event.preventDefault();
      event.stopImmediatePropagation();
    }
  }, true);
  document.querySelectorAll('.oix-vanity-product .oix-vanity-body meta[charset], .oix-vanity-product .oix-vanity-body hr').forEach((element) => element.remove());
  document.querySelectorAll('.oix-vanity-product .oix-vanity-body p').forEach((paragraph) => {
    if (!paragraph.textContent.trim() && !paragraph.querySelector('img, video, iframe')) paragraph.remove();
  });
  document.querySelectorAll('.oix-vanity-product .oix-vanity-faq p').forEach((paragraph) => {
    if (paragraph.textContent.trim().endsWith('?') && !paragraph.querySelector('strong, b')) {
      const question = document.createElement('strong');
      while (paragraph.firstChild) question.appendChild(paragraph.firstChild);
      paragraph.appendChild(question);
    }
  });
  } catch(e) { console.error(e); }
})();

})();
